module.exports = __webpack_public_path__ + "static/white_3ufjj-0c6b03a06375d39ad6801d2cae63a367.jpg";